import { Link } from "gatsby";
import React, { useEffect, useState } from "react";
import { useConsent } from "./ConsentContext";

export const CookieConsentBanner = () => {
  const {
    hasChoice,
    hydrated,
    settingsOpen,
    consent,
    acceptAll,
    rejectNonEssential,
    updateConsent,
    openSettings,
    closeSettings,
  } = useConsent();

  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    if (!settingsOpen) return;
    setAnalytics(consent.analytics);
    setMarketing(consent.marketing);
  }, [settingsOpen, consent.analytics, consent.marketing]);

  if (!hydrated) return null;

  const showBanner = !hasChoice || settingsOpen;
  if (!showBanner) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[100] p-4 sm:p-6 pointer-events-none"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-lg border border-[#313131] bg-[#fafafa] text-[#313131] shadow-lg p-5 sm:p-6 font-nunito">
        <h2
          id="cookie-consent-title"
          className="text-lg sm:text-xl font-bold mb-2"
        >
          Cookie preferences
        </h2>
        <p
          id="cookie-consent-desc"
          className="text-sm sm:text-base font-dinnext font-light leading-relaxed mb-4"
        >
          We use necessary cookies to run the site and optional cookies for
          analytics and marketing. Accessibility tools stay available. See our{" "}
          <Link to="/privacy-policy" className="underline font-medium">
            Privacy Policy
          </Link>
          .
        </p>

        {settingsOpen && (
          <div className="space-y-3 mb-4 text-sm font-dinnext">
            <label className="flex items-start gap-3 min-h-[44px]">
              <input type="checkbox" checked disabled className="mt-1" />
              <span>
                <strong>Necessary</strong> — required for basic site features
              </span>
            </label>
            <label className="flex items-start gap-3 min-h-[44px] cursor-pointer">
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                className="mt-1"
              />
              <span>
                <strong>Analytics</strong> — Google Analytics (GA4)
              </span>
            </label>
            <label className="flex items-start gap-3 min-h-[44px] cursor-pointer">
              <input
                type="checkbox"
                checked={marketing}
                onChange={(e) => setMarketing(e.target.checked)}
                className="mt-1"
              />
              <span>
                <strong>Marketing</strong> — Meta Pixel, AdRoll, Elfsight
              </span>
            </label>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-end">
          {settingsOpen ? (
            <>
              {hasChoice && (
                <button
                  type="button"
                  onClick={closeSettings}
                  className="min-h-[44px] px-4 py-2 text-sm underline order-3 sm:order-1 sm:mr-auto"
                >
                  Cancel
                </button>
              )}
              <button
                type="button"
                onClick={() => updateConsent({ analytics, marketing })}
                className="min-h-[44px] px-5 py-2 text-sm font-bold border border-[#313131] bg-white hover:bg-[#313131] hover:text-white transition-colors"
              >
                Save preferences
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                onClick={openSettings}
                className="min-h-[44px] px-4 py-2 text-sm underline order-3 sm:order-1 sm:mr-auto"
              >
                Customize
              </button>
              <button
                type="button"
                onClick={rejectNonEssential}
                className="min-h-[44px] px-5 py-2 text-sm font-bold border border-[#313131] bg-white hover:bg-[#313131] hover:text-white transition-colors"
              >
                Reject non-essential
              </button>
            </>
          )}
          <button
            type="button"
            onClick={acceptAll}
            className="min-h-[44px] px-5 py-2 text-sm font-bold bg-[#313131] text-white hover:bg-black transition-colors"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};
